import { Option } from '@sapphire/result';

import { PROJECT_TYPE } from '@ps/survey-kernel';

import {
  SURVEY_CLASSIFICATION_KIND,
  SURVEY_CLASSIFICATION_ROLE,
} from '../constants/survey-classification.constants';
import {
  isGroupedParent,
  isTrackerParent,
} from '../survey-project-stats/survey-project-stats';
import type {
  PreDraftSurveyClassification,
  SurveyClassification,
} from '../models/survey-classification.model';
import type { Survey } from '../models/survey.model';
import type { SurveyLocaleData } from '../models/survey-locale-data.model';

// Use directly for branching/match flows. For a plain boolean, use SurveyKind.
export function classifySurvey(survey: Survey): SurveyClassification {
  const mc = Option.from(survey.mc).unwrapOr({ parent: false, svp: false });

  if (survey.mcUniqueId && !mc.svp) {
    return {
      kind: SURVEY_CLASSIFICATION_KIND.MC,
      role: SURVEY_CLASSIFICATION_ROLE.STANDALONE,
    };
  }

  if (survey.projectType === PROJECT_TYPE.MCQB) {
    return {
      kind: SURVEY_CLASSIFICATION_KIND.GROUP_MC,
      role:
        mc.parent && mc.svp
          ? SURVEY_CLASSIFICATION_ROLE.PARENT
          : SURVEY_CLASSIFICATION_ROLE.CHILD,
    };
  }

  if (survey.projectType === PROJECT_TYPE.TRACKER) {
    return {
      kind: SURVEY_CLASSIFICATION_KIND.TRACKER,
      role: isTrackerParent(survey)
        ? SURVEY_CLASSIFICATION_ROLE.PARENT
        : SURVEY_CLASSIFICATION_ROLE.CHILD,
    };
  }

  if (survey.projectType === PROJECT_TYPE.GROUPED) {
    return {
      kind: SURVEY_CLASSIFICATION_KIND.GROUPED,
      role: isGroupedParent(survey)
        ? SURVEY_CLASSIFICATION_ROLE.PARENT
        : SURVEY_CLASSIFICATION_ROLE.CHILD,
    };
  }

  return {
    kind: SURVEY_CLASSIFICATION_KIND.STANDARD,
    role: SURVEY_CLASSIFICATION_ROLE.STANDALONE,
  };
}

export function classifyPreDraftSurvey(
  localeData: readonly SurveyLocaleData[],
): PreDraftSurveyClassification {
  if (localeData.length > 1) {
    return { kind: SURVEY_CLASSIFICATION_KIND.MC };
  }

  return { kind: SURVEY_CLASSIFICATION_KIND.STANDARD };
}
